module.exports = __webpack_public_path__ + "static/media/sohookd-marketplace-1200x208.46007004.png";